import React from 'react'
import { useTranslation } from 'react-i18next'
import { Breadcrumbs, Crumb } from '@carsys/ui'
import { pathCMSNewsItem, pathCMSNewsList, pathCMSPromotionItem, pathCMSPromotionsList } from 'app/wholesaler/routing'
import NewsItemBreadCrumb from 'app/wholesaler/cms/components/news/NewsItemBreadCrumb'
import PromotionItemBreadCrumb from 'app/wholesaler/cms/components/promotions/PromotionItemBreadCrumb'
import { useIsPortal } from 'utils/Subscription/PermissionSelector'

export const WholesalerBreadCrumbs: React.FC<React.ComponentProps<typeof Breadcrumbs>> = ({ ...props }) => {
  const { t } = useTranslation()
  const isPortal = useIsPortal()
  return (
    <Breadcrumbs {...props}>
      {/* Only GMS has a dedicated wholesaler page, portal has this on the dashboard */}
      {!isPortal && <Crumb data-testid='crumb-wholesaler' key='crumb-wholesaler' path='/wholesaler' text={t('wholesaler-space.title')} />}
      <Crumb
        data-testid='crumb-wholesaler-cms-news-list'
        key='crumb-wholesaler-cms-news-list'
        path={pathCMSNewsList()}
        text={t('cms-news.news-title')}
      />
      <Crumb data-testid='crumb-wholesaler-cms-news-item' key='crumb-wholesaler-cms-news-item' path={pathCMSNewsItem()}>
        <NewsItemBreadCrumb />
      </Crumb>
      <Crumb
        data-testid='crumb-wholesaler-cms-promotions-list'
        key='crumb-wholesaler-cms-promotions-list'
        path={pathCMSPromotionsList()}
        text={t('cms-promotion.promotion-title')}
      />
      <Crumb data-testid='crumb-wholesaler-cms-promotions-item' key='crumb-wholesaler-cms-promotions-item' path={pathCMSPromotionItem()}>
        <PromotionItemBreadCrumb />
      </Crumb>
    </Breadcrumbs>
  )
}

export default WholesalerBreadCrumbs
